if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
	  
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      //console.log("formData",formData);
	  
	  /***********************************KKK**************************************/
	var currentItemSku = formData.get('itemsku');
	var webumdisplay = formData.get('webumdisplay');
	var webumqty = formData.get('qtyforerp');
	var variantId = formData.get('id');
	var currentQty = formData.get('quantity')?  formData.get('quantity') : 1;
	var availability = $(".availability"+currentItemSku).val();;
	var isAddtoCart = true;
		
	  var Inprocess='';
	  var MyCart;	  
		console.log("Before Cart Call");	  
		fetch('/cart.js', {method: 'GET',   cache: 'no-store'})
		.then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		})
		.then(cart => {
			const existingItem = cart.items.find(item => 
			item.variant_id.toString() === variantId
		  );		  
		const alreadyInCart = existingItem ? existingItem.quantity : 0;
		//isAddtoCart = checkCartData(currentItemSku,webumdisplay,webumqty,alreadyInCart,currentQuantity)
		var TotalOrderQty = parseInt(currentQty) + parseInt(alreadyInCart);
		availability=parseInt(availability);
		console.log("currentItemSku => ",currentItemSku, "CQty => ",currentQty," AlreadyinCart",alreadyInCart,"TotalOrderQty =>", TotalOrderQty," Availability =>",availability);
		
		if(TotalOrderQty > availability)
        {
          isAddtoCart = false;
          alert("You have added more than we have available. For assistance with an alternate product, or to source more of this one, call 800-284-5449.")
        }
			
			
		Inprocess=12;	
		})
		.catch(error => {
			console.error('There was a problem with the fetch operation:', error);
		});		
		
		
		await sleep(1000); // Wait for 2 seconds
		if(Inprocess == "")	await sleep(1000); // Wait for 2 seconds

		
		console.log("Inprocess", Inprocess,"isAddtoCart => ",isAddtoCart);
		console.log("After Cart Call");
		/************************ *******************************************************************************/
	  if(isAddtoCart)
	  {
		  fetch(`${routes.cart_add_url}`, config)
			.then((response) => response.json())
			.then((response) => {
			  if (response.status) {
				publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
				this.handleErrorMessage(response.description);
	
				const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
				if (!soldOutMessage) return;
				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.querySelector('span').classList.add('hidden');
				soldOutMessage.classList.remove('hidden');
				this.error = true;
				return;
			  } else if (!this.cart) {
				window.location = window.routes.cart_url;
				return;
			  }
	
			  if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
			  this.error = false;
			  const quickAddModal = this.closest('quick-add-modal');
			  if (quickAddModal) {
				document.body.addEventListener('modalClosed', () => {
				  setTimeout(() => { this.cart.renderContents(response) });
				}, { once: true });
				quickAddModal.hide(true);
			  } else {
				this.cart.renderContents(response);
			  }
			})
			.catch((e) => {
			  console.error(e);
			})
			.finally(() => {
			  this.submitButton.classList.remove('loading');
			  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
			  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
			  this.querySelector('.loading-overlay__spinner').classList.add('hidden');
			});
	  }
	  else
	  {
		  this.submitButton.classList.remove('loading');
			  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
			  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
			  this.querySelector('.loading-overlay__spinner').classList.add('hidden');
	  }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}